import styled from '@emotion/styled'

import MobileChevronLeftIcon from '@/assets/icons/mobile-chevron-left.svg?react'
import { COLORS } from '@/styles/colors'

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -3px;
`

export const OptionRow = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 20px 0;
  background-color: ${COLORS.bgWhite};
  cursor: pointer;
  text-align: left;
  border: none;

  & + & {
    border-top: 1px solid ${COLORS.strokeStatic};
  }
`

export const OptionIconBox = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`

export const OptionTextWrap = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`

export const OptionLabel = styled.span`
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`

export const OptionDesc = styled.span`
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.textSecondary};
`

export const ChevronRight = styled(MobileChevronLeftIcon)`
  flex-shrink: 0;
  transform: rotate(180deg);

  path {
    fill: #d4d5d8;
  }
`
